import type { DrawerItem } from '@/components/subject/configs.ts';

const experiments: DrawerItem[] = [
  // {
  //   title: '1.概率',
  //   icon: 'lucide:folder',
  //   children: [
  //     { title: '抛图钉问题', icon: 'lucide:flask-conical', route: `/experiment/put-pin` },
  //   ],
  // },
];

const experimentConfig = {
  experiments,
};

export { experimentConfig };
